import { MutationTree } from 'vuex'
import { State } from './state'

export enum RequestMutationTypes {
  SET_HOSP_CODE  = 'SET_HOSP_CODE',
  SET_DEPT_CODE  = 'SET_DEPT_CODE',
  SET_APPOINT_TYPE = 'SET_APPOINT_TYPE'
}

export type Mutations<S = State> = {
  [RequestMutationTypes.SET_HOSP_CODE](state: S, payload: String): void,
  [RequestMutationTypes.SET_DEPT_CODE](state: S, payload: String): void,
  [RequestMutationTypes.SET_APPOINT_TYPE](state: S, payload: Number): void
}

export const mutations: MutationTree<State> & Mutations = {
  [RequestMutationTypes.SET_HOSP_CODE](state, payload: String) {
    state.hospCode = payload;
  },
  [RequestMutationTypes.SET_DEPT_CODE](state, payload:String) {
    state.deptCode = payload;
    
  },
  [RequestMutationTypes.SET_APPOINT_TYPE](state, payload:Number) {
    state.appointType = payload;
  },
}
